const dummyUser = {
    userId: 0,
    username: '',
    password: ''
};

export default dummyUser;